import { render, staticRenderFns } from "./NotifyCallBack.vue?vue&type=template&id=5ea2973a&"
import script from "./NotifyCallBack.vue?vue&type=script&lang=js&"
export * from "./NotifyCallBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports